import { ContentViewStyle } from '@levelapp/softfabric';
export default class SliderViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.styleText = {
            paddingBottom: 5,
            textAlign: 'center',
            width: 45,
            backgroundColor: 'red',
            color: 'black'
        };
    }
}
